import { render, staticRenderFns } from "./gasHistory.vue?vue&type=template&id=9c4b1680&scoped=true&"
import script from "./gasHistory.vue?vue&type=script&lang=js&"
export * from "./gasHistory.vue?vue&type=script&lang=js&"
import style0 from "./gasHistory.vue?vue&type=style&index=0&id=9c4b1680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4b1680",
  null
  
)

export default component.exports